import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/Button';
import { Card, EmptyState } from '@/components/Card';
import { useToast } from '@/components/Toast';
import { SetupWizard } from '@/features/wizard/SetupWizard';
import { useProjectStore } from '@/app/projectStore';

/** 新建项目后的分步引导页 */
export function WizardPage() {
  const { projectId = '' } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const { getProject, updateProject, setLastProjectId, ready } = useProjectStore();
  const project = getProject(projectId);

  // 只在切换到另一个项目时记录「最近打开」；依赖项目对象会在向导里每敲一个字重跑一次。
  useEffect(() => {
    if (projectId) setLastProjectId(projectId);
  }, [projectId, setLastProjectId]);

  if (!ready) return null;

  if (!project) {
    return (
      <Card>
        <EmptyState
          title="找不到这个项目"
          description="项目可能已经被删除，或链接里的编号不正确。"
          action={
            <Button size="lg" variant="primary" onClick={() => navigate('/')}>
              返回项目列表
            </Button>
          }
        />
      </Card>
    );
  }

  return (
    <SetupWizard
      project={project}
      onUpdate={(updater) => updateProject(project.id, updater)}
      onFinish={() => {
        toast.ok('参数已保存', '可以继续微调，结果会实时更新。');
        navigate(`/p/${project.id}`);
      }}
      onExit={() => navigate(`/p/${project.id}`)}
    />
  );
}
